import React from "react";
import { showTopSpinView } from "../../../../../../../common-deprecated/redux/actions/UtilActions";
import { useBnbSelector } from "../../../../redux/store";
import * as Styles from "./styles/TopSpinViewToggle";
import { BnbLabel } from "../../../../utils/labels";
import { useDispatch } from "../../../../../../../shared-logic/redux/store";

const TopSpinViewToggle = (): JSX.Element => {
    const dispatch = useDispatch();
    const isActive = useBnbSelector((state) => state.utils.showTopSpinView);

    return (
        <Styles.Wrapper>
            <Styles.Label>
                <BnbLabel label="spinTopView" />
            </Styles.Label>
            <Styles.Status
                isActive={isActive}
                onClick={() => {
                    dispatch(showTopSpinView(!isActive));
                }}
            >
                <BnbLabel label="spinTopViewOpen" />
            </Styles.Status>
            <Styles.Status
                isActive={!isActive}
                onClick={() => {
                    dispatch(showTopSpinView(!isActive));
                }}
            >
                <BnbLabel label="spinTopViewClosed" />
            </Styles.Status>
        </Styles.Wrapper>
    );
};

export default TopSpinViewToggle;
